import { InfoVariant } from "./hover-card.types";

export const INFO_COLORS: Record<InfoVariant, string> = {
    warning: "var(--mantine-color-text-warning-default)",
};
